import HeaderVerde from '../HeaderVerde'
import Input from '../Input'
import Select from '../Select'
import Observacoes from '../Observacoes'
import Caixa from '../Caixa'
import CheckContainer from '../CheckContainer'
import CheckBox from '../CheckBox'
import React from 'react'

import { useSelector } from 'react-redux'

const TOprofissionaisNoEstabelecimento = (props) => {
    const modulo = props.modulo
    const updatedForm = useSelector((state) => state.addForm.qtdModulos[modulo])
    const ficha = useSelector((state) => state.addForm.ficha)

    return (
        <>
            {RenderModulo()}
        </>
    )

    function RenderModulo() {
        let partes = []
        if(ficha[modulo]) var qtdFicha = ficha[modulo].length
        let quantidade = updatedForm || qtdFicha
        for (let n = 0; n < quantidade; n++) {
            partes.push(
                <Caixa>
                    <HeaderVerde texto="TERAPEUTAS OCUPACIONAIS QUE TRABALHAM NO ESTABELECIMENTO ATUALMENTE" />
                    <div style={{ textAlign: "left" }}>
                        <Input label="Profissional" nome="toprofiss" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="36vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Crefito Nº" nome="tocrefiton" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" />
                        <Select label="Responsável Técnico do Serviço" nome="toresponsavel" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="15vw" widthMobile="80vw" marginR="3vw"
                            array={["Sim", "Não"]} />
                        <Input label="Dias/Horas de Trabalho" nome="tohora" tipo="text" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" />
                        <Input label="Média de Pacientes Atendidos por Grupo/Turno" nome="tomedia" modulo={modulo} index={n}
                            componentDisplay="inline-grid" widthWeb="10vw" widthMobile="80vw" marginR="3vw" />
                    </div>
                </Caixa >
            )
        }
        return partes
    }
}

export default TOprofissionaisNoEstabelecimento